/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInlineCode = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m13.039 4.725-4 14 1.923.55 4-14zM6.293 7.293l1.414 1.414L4.414 12l3.293 3.293-1.414 1.414L1.586 12zm11.414 0-1.414 1.414L19.586 12l-3.293 3.293 1.414 1.414L22.414 12z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgInlineCode as InlineCode };
